import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { concatMap, delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class RouterService {
    private readonly location = inject(Location);

    // Fronta pro požadavky na odstranění parametrů
    private paramRemovalQueue$ = new Subject<string>();

    constructor() {
        // Posloucháme frontu a zpracováváme požadavky sekvenčně
        this.paramRemovalQueue$
            .pipe(
                takeUntilDestroyed(),
                delay(100),
                concatMap((param) => this.processRemoveQueryParam(param))
            )
            .subscribe();
    }

    removeQueryParam(param: string): void {
        // Přidáme požadavek na odstranění do fronty
        this.paramRemovalQueue$.next(param);
    }

    private processRemoveQueryParam(param: string): Promise<void> {
        return new Promise((resolve) => {
            // Nespoléháme se na stav Angular routeru, ale na reálnou URL v prohlížeči,
            // abychom měli vždy aktuální data pro další krok ve frontě.
            const currentParams = new URLSearchParams(window.location.search);
            currentParams.delete(param);
            const query = currentParams.toString();

            // Získáme čistou cestu bez query parametrů.
            // location.path() může obsahovat staré query parametry, pokud se URL mění rychle.
            const path = this.location.path().split('?')[0];

            // Použijeme location.replaceState s čistou cestou a novými query parametry.
            this.location.replaceState(path, query);
            resolve();
        });
    }
}
